import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@chakra-ui/react';

import { IMessageToolCall } from '../../../../../../api/types';

interface UnknownToolCallProps {
    toolCall: IMessageToolCall;
}

export const UnknownToolCall: FC<UnknownToolCallProps> = ({ toolCall }) => {
    const { t } = useTranslation('translations');
    const prettyToolName = toolCall.function_name
        .replaceAll('-', ' ')
        .replaceAll('_', ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
    const parseToolCall = (): Record<string, unknown> | undefined => {
        try {
            return JSON.parse(toolCall.function_args);
        } catch {
            return undefined;
        }
    };
    const parsedToolCall = parseToolCall();

    const singleArgument =
        parsedToolCall && Object.keys(parsedToolCall).length === 1 && Object.values(parsedToolCall)[0];
    const transKey = singleArgument ? 'chat-tab.unknown-tool.with-arguments' : 'chat-tab.unknown-tool.no-arguments';

    return <Text>{t(transKey, { tool_name: prettyToolName, argument: singleArgument })}</Text>;
};
